export const STORAGE_WELCOME_MODAL_KEY = 'bethere-welcome-modal-showed'


export const OG_DEFAULT_IMAGE_URL = `${window.location.origin}/betheremap-seo-image.png?ver=1.0.0`

export const STORAGE_JWT_KEY = 'bethere-jwt'

export const STORAGE_SESSION_ID_KEY = 'bethere-session-id'
export const STORAGE_COOKIE_SETTINGS_KEY = 'bethere-cookie-settings'

export const STORAGE_USER_LOCATION_KEY = 'bethere-user-location'
